export const responseStatusCodes = {
  ok: 200,
  badRequest: 400,
  unauthorised: 401,
  loginRequired: 418,
};
